import type { CustomerAnalytics } from './analytics'

export type CustomerSortKey = 'orders' | 'total' | 'averageCheck' | 'lastOrder'
export type CustomerSortDirection = 'asc' | 'desc'

export interface CustomerSort {
  key: CustomerSortKey
  direction: CustomerSortDirection
}

export const DEFAULT_CUSTOMER_SORT: CustomerSort = {
  key: 'orders',
  direction: 'desc',
}

function sortableValue(customer: CustomerAnalytics, key: CustomerSortKey): number {
  if (key === 'orders') return customer.orderCount
  if (key === 'total') return customer.totalSpent
  if (key === 'averageCheck') return customer.averageCheck
  const timestamp = Date.parse(customer.lastOrderAt)
  return Number.isFinite(timestamp) ? timestamp : 0
}

export function sortCustomers(
  customers: readonly CustomerAnalytics[],
  sort: CustomerSort,
): CustomerAnalytics[] {
  const direction = sort.direction === 'asc' ? 1 : -1
  return [...customers].sort((left, right) => {
    const difference = sortableValue(left, sort.key) - sortableValue(right, sort.key)
    if (difference !== 0) return difference * direction
    return left.name.localeCompare(right.name, 'ru-RU') || left.id.localeCompare(right.id)
  })
}

export function nextCustomerSort(current: CustomerSort, key: CustomerSortKey): CustomerSort {
  if (current.key !== key) return { key, direction: 'desc' }
  return { key, direction: current.direction === 'desc' ? 'asc' : 'desc' }
}
